/* eslint-disable no-useless-concat */
import React from "react";
import { gql, useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import {
  Paper,

  Icon,

} from "@mui/material";
import FullScreenLoading from "../HOC/FunctionComponents/LoadingPages/FullScreenLoading";
import { ACTIVITY, DELETE_ACTIVITY } from "./Graphql";
import { KeyValuePair } from "../HOC/CustomComponents/KeyValuePair";

import { Globals } from "../HOC/Classes/Globals";

import Grid from "@mui/material/Unstable_Grid2";
import TitleAppBar from "../../Layout/TitleAppBar";
import { pushUrl } from "../HOC/CustomFunctions/pushUrl";
import LongMenu from "../../Layout/MenuAppBar";
import NotFound from "../../Error/NotFound";
import { StyledLoading, classesLoad } from "../../GlobalStyles/LoadingStyle";
import { RootStyleView, classesView } from "../../GlobalStyles/ViewStyle";
import MutationWithDialog from "../HOC/CustomComponents/MutationWithDialog";
const ActivityView = (props) => {
  const activityId = props.match.params.id?.trim();
  const { t } = useTranslation();
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleOpenDialog = () => {
    setOpenDialog(true);
  };
  const { loading, data } = useQuery(
    gql`
      ${ACTIVITY.query}
    `,
    {
      fetchPolicy: "network-only",
      variables: { id: parseInt(activityId) },
    }
  );
  const user = Globals.user;

  const canEdit = user.hasPermission("freight.activity.update");



  const icons = [
    {
      id: "edit",
      action: () => pushUrl(props, `/admin/activity/${activityId}/edit`),
      permission: canEdit,
    },
    {
      id: "delete",
      action: handleOpenDialog,
      permission: user?.hasPermission("freight.activity.delete"),
    },
  ];
  return loading ? (
    <StyledLoading
      container
      item
      justifyContent="center"
      className={classesLoad.main}
    >
      <FullScreenLoading height={"100%"} />
    </StyledLoading>
  ) : !data.activity ? (
    <NotFound />
  ) : (
    <>

      {openDialog && (
        <MutationWithDialog
          mutaion={DELETE_ACTIVITY.query}
          setOpenDelete={setOpenDialog}
          openDelete={openDialog}
          dialogTitle={t("deleteRecord")}
          dialogContent={t("deleteRecordMessage")}
          mutaionProps={{
            variables: { id: parseInt(activityId) },
          }}
          onCompleted={() => pushUrl(props, `/admin/activity`)}
          onCompleteMessage={t("successfullyDeletedRecord")}
        />
      )}
      <TitleAppBar path={props.match.path}>
        <LongMenu icons={icons} />
      </TitleAppBar>
      <RootStyleView spacing={2} p={2} justifyContent="center">
        <Paper container className={classesView.paper} component={Grid}>
          <KeyValuePair title={t("code")} value={data?.activity?.code} />
          <KeyValuePair title={t("name")} value={data?.activity?.name} />
          <KeyValuePair
            title={t("active")}
            value={
              data?.activity?.active ? (
                <Icon className={classesView.iconColor}>
                  check_circle_outline
                </Icon>
              ) : (
                <Icon color="error">highlight_off</Icon>
              )
            }
          />
        </Paper>


      </RootStyleView>
    </>
  );
};

export default ActivityView;
